// extracted by mini-css-extract-plugin
export var alignLeft = "n_p8 d_fp d_bG d_dv";
export var alignCenter = "n_bP d_fq d_bD d_dw";
export var alignRight = "n_p9 d_fr d_bH d_dx";
export var customRow = "n_qb d_bD d_Z";